/**
 * Email domains for organizations that provision accounts centrally.
 *
 * Users at these domains are invited by their instructor. When they sign up
 * themselves instead they land in the public org rather than their school's,
 * which has to be unpicked by hand later, so the create account form warns
 * them first. The warning is advisory - they can still sign up (VP-12499).
 *
 * Subdomains match as well, so 'nightingale.edu' also covers
 * 'learn.nightingale.edu'.
 */
const managedDomains = [
  'nightingale.edu',
];

function emailDomain(email) {
  const at = String(email || '').lastIndexOf('@');
  return at === -1 ? '' : String(email).slice(at + 1).trim().toLowerCase();
}

function isManagedDomain(email) {
  const domain = emailDomain(email);
  if (!domain) {
    return false;
  }
  return managedDomains.some(
    (managed) => domain === managed || domain.endsWith(`.${managed}`)
  );
}

exports.managedDomains = managedDomains;
exports.emailDomain = emailDomain;
exports.isManagedDomain = isManagedDomain;
